import { render } from "./BlFormFieldSignature.vue?vue&type=template&id=119ae56e&scoped=true"
import script from "./BlFormFieldSignature.vue?vue&type=script&lang=js"
export * from "./BlFormFieldSignature.vue?vue&type=script&lang=js"

import "./BlFormFieldSignature.vue?vue&type=style&index=0&id=119ae56e&lang=scss&scoped=true"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119ae56e"]])

export default __exports__